import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ModivcareBillableTripRead } from 'src/common/external/bambi-api/bambiApi';

interface ModivcareState {
  // Filters
  filterSentAtGte?: string;
  filterSentAtLte?: string;
  // Selection, keyed by billable trip id
  selectedRows: Record<
    ModivcareBillableTripRead['trip_id'],
    ModivcareBillableTripRead | null
  >;
  bulkPriceModal: {
    isOpen: boolean;
    billableTripsToPrice: ModivcareBillableTripRead[];
  };
}

export const initialState: ModivcareState = {
  selectedRows: {},
  bulkPriceModal: {
    isOpen: false,
    billableTripsToPrice: [],
  },
};

export const modivcareSlice = createSlice({
  name: 'modivcare',
  initialState,
  reducers: {
    setFilterSentAtRange(
      state,
      action: PayloadAction<{ rangeStart?: string; rangeEnd?: string }>
    ) {
      state.filterSentAtGte = action.payload.rangeStart;
      state.filterSentAtLte = action.payload.rangeEnd;
      state.selectedRows = {};
    },
    setSelectedRows(
      state,
      action: PayloadAction<
        Record<ModivcareBillableTripRead['trip_id'], ModivcareBillableTripRead>
      >
    ) {
      state.selectedRows = action.payload;
    },
    clearSelectedRows(state) {
      state.selectedRows = {};
    },
    onBulkPriceStart(
      state,
      action: PayloadAction<ModivcareBillableTripRead[]>
    ) {
      state.bulkPriceModal.billableTripsToPrice = action.payload;
      state.bulkPriceModal.isOpen = true;
    },
    onBulkPriceModalClose(state) {
      state.bulkPriceModal = initialState.bulkPriceModal;
      state.selectedRows = {};
    },
  },
});

export const {
  setFilterSentAtRange,
  setSelectedRows,
  clearSelectedRows,
  onBulkPriceStart,
  onBulkPriceModalClose,
} = modivcareSlice.actions;
